export default __webpack_public_path__ + "static/media/img_2_7.6a12011f.png";